export default "__VITE_ASSET__UXiWhekfqevZZKisIRYSGw__"